import { GridElement } from '..'

export const Embed: React.FC<GridElement> = props => {
    const preview = props.value?.preview

    if (!preview) {
        return null
    }

    return <div dangerouslySetInnerHTML={{ __html: preview }} />
}
